import React from 'react';

import { Image } from '../../Image/Image';
import { PageComponent } from '../../PageComponent/PageComponent';
import { RichText } from '../../RichText/RichText';

import { CarouselSlideProps } from '../Carousel.types';

import * as classes from './CarouselSlideWithImage.module.scss';

const CarouselSlideWithImage: React.FC<CarouselSlideProps> = ({
    title,
    icons,
    singleColumnContent,
    multiColumnContent,
    image,
}) => {
    return (
        <div className={classes.carouselSlideContainer}>
            <PageComponent>
                <div className={classes.carouselContentContainer}>
                    <div className={classes.col}>
                        {icons?.map((el, i) => {
                            return (
                                <Image key={i} image={el} classWrapper={classes.iconWrapper} classImg={classes.icon} />
                            );
                        })}
                        <RichText content={title} textSize="heading3" />
                        <RichText content={singleColumnContent} textSize="text1" bulletType="CheckMark" />
                    </div>
                    <div className={classes.colMd}>
                        {image && (
                            <div className={classes.wrapper}>
                                <Image image={image} classWrapper={classes.imgWrapper} />
                            </div>
                        )}
                    </div>
                    <div className={classes.col}>
                        {multiColumnContent?.map((el, i) => {
                            return (
                                <div key={i}>
                                    <RichText content={el.text} noHeadings={true} />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </PageComponent>
        </div>
    );
};

export default CarouselSlideWithImage;
